<template>
    <div class="mbody">
        <h1 style="justify-content: center;display: flex;" class="tit">COAL NFT</h1>


        <div>
            <h3><span class="mdropcap">K</span>
                <span style="font-size: 24px;">rampus has come early this year. Come collect your coals if you
                    have been
                    naughty. 
                    Mint a Coal NFT and try to strenghen it into a <span class="pd">&#128142; </span><span
                        class="pia">Diamond
                    </span><span class="pd">&#128142;</span>, be
                    careful someone else doesn't steal your coal, after
                    all, you are signing a deal with the devil and krampus.</span>
            </h3>
        </div>


        <h2 style="justify-content: center;display: flex;"><button class="b_sign" @click="show_mint()">MINT</button>
        </h2>
        <br>
        <br>
        <hr class="rounded mhr">
        <br>

        <h1 style="justify-content: center;display: flex;" class="tit">FAQ / Dark Paper</h1>
        <div v-for="(x, xidx) in qa" :key="xidx">
            <h3 class="q_class"># {{ x.q }} ?</h3>
            <h5 class="a_class">
                <span class="mindent">
                    <p v-html="'- ' + x.a"></p>
                </span>
            </h5>

            <hr class="rounded">

        </div>
    </div>
</template>

<script>

import ENUMS from '../Enums';

export default {
    name: ENUMS.VIEWS.MAIN
    , methods: {
        show_mint() {
            this.$store.commit("changeView", ENUMS.VIEWS.MINT)
            
            setTimeout(() => {

                var papsnd = new Audio('/paper.mp3');
                papsnd.play();
            }, 50);

        }
    }
    , data() {
        return {
            ENUMS: ENUMS
            , qa: [
                { q: "What is a stealable NFT", a: "It is an NFT that could be stolen. Each time it is stolen it becomes tougher and harder to steal." },
                { q: "Why a stealable NFT", a: "What is the most exciting attribute of real art? Thats right, that it can be stolen." },
                { q: "But haven't NFTs been stolen before", a: "No, they were hacked." },
                { q: "How is it implemented", a: "Each minted NFT comes with a unique Hash associated with it which represents its strength. Taking inspiration from how Bitcoin implements difficulty of mining a block, the leading zeros of the hash represent its strength. The more zeros the harder it is to steal." },
                { q: "How can a thief steal my NFT", a: "If someone comes up with a nonce that can increase the strength of your NFT they will steal it." },
                { q: "How do I protect my NFT", a: "At mint the NFT enters a grace period of 7 days in which it can't be stolen, you can always try to find the nonce that increases the strength of your NFT and strenghen it." },
                { q: "Can't a miner front-run me and steal the NFT themselves", a: "No, you will first submit the hash of the nonce you have found and lock it in. then you wait for the confirmation of your locked nonce to see if it is locked in your name. Then you will submit the nonce itself. The miner can not lock the nonce you have found before you. and if they do you will get notified and stop sending the nonce. Things will get complicated and interesting if the project takes off and you might need to bribe a miner or become a miner to mine your own block to prevent announcing the nonce to the network and this is one of the exciting things that the project is looking into. or Zero-Knowledge proofs may come to the rescue." },
                { q: "How many coal NFTs exist", a: "6969 the holy number as the lord in his infinite wisdom intended. " },
                { q: "Why would I mint an NFT when I can steal someone else's", a: "There is a lifetime 2% royalty for the minter and If you feel like you can steal an NFT then you definitley have the means to strenghen your own NFT as well. This project is an experiment thats why the mint price is set to a low price and minting available for everyone, not only to a whitelisted early adopters. If the price of the NFT you minted exceeds 666 $KDA you will have made your $KDA back on each sale of the NFT. In dollar terms, \"we\" (as in you and us who believe in the Kadena network) believe it will be a much less number." },
                { q: "Are there any benefits of minting this NFT", a: "The minter will always share a 2% royalty on any sale of the NFT regardless of whether they are the current owner or not. A quick calculation shows you that if the price of the NFT you minted exceeds 666 $KDA you will make your money back on each sale of the NFT. Plus, we are working on other projects like onchain games and minters will have priviledges in those projects in the future." },
                { q: "Why not a free mint model", a: "Notice that the minter has a 2% royalty share. If minting was free one person could become the owner of all royalties. So there must exist a trade-off between owning the coal and protecting it, or choosing to be royalty collector so there should be a meaningful price that both encourages the engagement and disencourages gobbling up all the NFTs solely for the royalty fees. " },
                { q: "what are some things I should know about the strength of my NFT", a: "you will most likely end up with a strength of around 3 at minting time which is super low, but dont worry, you will have a week of grace period in which your NFT can not be stolen. Just by using the dumb miner provided in the \"My NFTs\" tab you can strengthen to over 20, but things start to get exponentially harder the stronger an NFT gets. According to simple calculations A state of the art miner working for 7 days might bring the strength of the NFT to 77 which is a acceptable strength for todays computing power." },
                { q: "How many NFTs can an account mint", a: "There is no hard limit. But if strenghening one NFT takes 'n' effort then having 10 of them will take '10n' so knock yourself out, buy them all if you feel like you can secure and strenghen them all." },
                { q: "How much is the project royalty", a: "Same as a minter, 2%, we are in this together" },
                { q: "Why Kadena", a: "It is the most sane chain as we see it sofar. The smart contract language is well designed and after the formal verification is fully implemented it will prevent bugs and hacks of smart contracts before deployment." },
                { q: "I can't mint", a: "Minting is only available on Chain 13." },
                { q: "Where Monke GIFs", a: "<a target=\"_blank\"  href=\"/monke.jpg\"> Get out of here.</a>" },
                { q: "What attributes do the NFTs possess", a: "At the moment the NFTs have 1 main attribute which is their strength and 5 attributes to better distinguish between NFTs which are indicated by emojis, there are HAT, HAND, PET, BACK and SKY slots." },
                { q: "Where White-Paper ", a: "You are reading it, its a little darker than a white-paper." },
                {
                    q: "Where can I buy Kadena", a: `The best place might be <a target="_blank" href="https://tradeogre.com/exchange/BTC-KDA">TradeOgre</a>, no need to KYC, just deposit some Bitcoin, Litecoin or XRP and trade
            for KDA.`},
                { q: "I don't have a wallet / My wallet doesn't work", a: `Download <a target="_blank" href="https://xwallet.kaddex.com/">X-Wallet</a> / site was only tested with X-Wallet. Other methods are in development. Use discord to request your favorite method.` }


            ]
        }
    }
}

</script>

<style scoped>
* {
    color: white;
    font: 17px/1.5 arial, helvetica, sans-serif;
    font-weight: bold;
}

.b_sign {
    font-weight: bold;
    color: white;
    width: 30%;
    height: 50px;
    text-shadow: rgb(255, 255, 255) .20em .13em;
    transition: all 1.5s ease-in-out;
}

.b_sign:hover {
    color: rgb(165, 11, 11);
    text-shadow: rgb(102, 102, 102) 0em 0em;
    font-size: 15;

}

.a_class {
    padding-left: 5%;
}

.q_class {
    padding-left: 1%;
}

.mdropcap {
    float: left;
    font-size: 69px;
    line-height: 1;
    font-weight: bold;
    margin-right: 9px;
    color: white;
    font-family: "Times New Roman", Times, serif;
    text-shadow: rgb(150, 150, 150) -.08em -.08em;
    animation: kramp 4s infinite alternate;
}

@keyframes kramp {
    0% {
        text-shadow: rgb(150, 150, 150) -.08em -.08em;

    }

    45% {
        text-shadow: rgb(150, 150, 150) -.08em -.08em;

    }

    48% {
        color: white;
    }

    49% {
        text-shadow: rgba(160, 1, 1, 0.699) -0.08em 0.08em;
        color: rgba(160, 1, 1, 0.699);
    }

    50% {
        text-shadow: rgba(160, 1, 1, 0.699) 0.08em -0.08em;
        color: white;

    }

    51% {
        text-shadow: rgba(160, 1, 1, 0.699) 0.08em 0.08em;
        color: rgba(160, 1, 1, 0.699);
    }

    52% {
        text-shadow: rgba(160, 1, 1, 0.699) 0.08em -0.08em;
        color: white;
    }

    55% {
        text-shadow: rgb(150, 150, 150) -.08em -.08em;

    }

    100% {
        text-shadow: rgb(150, 150, 150) -.08em -.08em;

    }

}

.pd {
    margin: 0px;
    /* color: aquamarine; */
    color: white;
    text-shadow: none;
    animation: dia 5s infinite alternate;
}

@keyframes dia {
    0% {
        color: white;
        text-shadow: none;

    }

    98% {
        color: white;
        text-shadow: none;

    }

    99% {
        color: transparent;
        text-shadow: 0 0 0 rgb(255, 255, 255);
    }

    100% {
        color: white;
        text-shadow: none;

    }
}

.pia {
    margin: 0px;
    animation: colorchange 5s infinite alternate;

}

@keyframes colorchange {
    0% {

        color: white;
    }

    30% {

        color: white;
    }

    50% {

        color: rgb(121, 233, 253);
    }

    70% {

        color: white;
    }

    100% {
        color: white;
    }

}
</style>